import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "welcome"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "grid-content"
};
const _hoisted_5 = {
  class: "list-box"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "grid-content"
};
const _hoisted_8 = {
  class: "list-box"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "grid-content"
};
const _hoisted_11 = {
  class: "list-box"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = ["onClick"];
import { onMounted, ref } from "vue";
import { ElMessage } from "element-plus";
import { getSystemInfo } from "@/store/cache";
export default {
  __name: 'Welcome',
  emits: ["send"],
  setup(__props, {
    emit: __emit
  }) {
    const title = ref(process.env.VUE_APP_TITLE);
    const version = ref(process.env.VUE_APP_VERSION);
    const samples = ref(["用小学生都能听懂的术语解释什么是量子纠缠", "能给一位6岁男孩的生日会提供一些创造性的建议吗？", "如何用 Go 语言实现支持代理 Http client 请求?"]);
    const plugins = ref([{
      value: "今日早报",
      text: "今日早报：获取当天全球的热门新闻事件列表"
    }, {
      value: "微博热搜",
      text: "微博热搜：新浪微博热搜榜，微博当日热搜榜单"
    }, {
      value: "今日头条",
      text: "今日头条：给用户推荐当天的头条新闻，周榜热文"
    }]);
    const capabilities = ref([{
      text: "轻松扮演翻译专家，程序员，AI 女友，文案高手...",
      value: ""
    }, {
      text: "国产大语言模型支持，百度文心，科大讯飞，ChatGLM...",
      value: ""
    }, {
      text: "绘画：马斯克开拖拉机，20世纪，中国农村。3:2",
      value: "绘画：马斯克开拖拉机，20世纪，中国农村。3:2"
    }]);
    onMounted(() => {
      getSystemInfo().then(res => {
        title.value = res.data.title;
      }).catch(e => {
        ElMessage.error("获取系统配置失败：" + e.message);
      });
    });
    const emits = __emit;
    const send = text => {
      emits("send", text);
    };
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(title.value) + "-" + _toDisplayString(version.value), 1), _createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_cache[0] || (_cache[0] = _createElementVNode("div", {
            class: "item-title"
          }, [_createElementVNode("div", null, [_createElementVNode("i", {
            class: "iconfont icon-quick-start"
          })]), _createElementVNode("div", null, "小试牛刀")], -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(samples.value, item => {
            return _openBlock(), _createElementBlock("li", {
              key: item
            }, [_createElementVNode("a", {
              onClick: $event => send(item)
            }, _toDisplayString(item), 9, _hoisted_6)]);
          }), 128))])])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "item-title"
          }, [_createElementVNode("div", null, [_createElementVNode("i", {
            class: "iconfont icon-plugin"
          })]), _createElementVNode("div", null, "插件增强")], -1)), _createElementVNode("div", _hoisted_8, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plugins.value, item => {
            return _openBlock(), _createElementBlock("li", {
              key: item.value
            }, [_createElementVNode("a", {
              onClick: $event => send(item.value)
            }, _toDisplayString(item.text), 9, _hoisted_9)]);
          }), 128))])])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_cache[2] || (_cache[2] = _createElementVNode("div", {
            class: "item-title"
          }, [_createElementVNode("div", null, [_createElementVNode("i", {
            class: "iconfont icon-control"
          })]), _createElementVNode("div", null, "能力扩展")], -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(capabilities.value, item => {
            return _openBlock(), _createElementBlock("li", {
              key: item
            }, [item.value === '' ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.text), 1)) : (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: $event => send(item.value)
            }, _toDisplayString(item.text), 9, _hoisted_13))]);
          }), 128))])])])]),
          _: 1
        })]),
        _: 1
      })])]);
    };
  }
};